import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const BOOK_IMAGE = 'https://cdn.magicpatterns.com/uploads/s5KS3b6L8LzyJFRNTPLuNK/ChatGPT_Image_25_feb_2026,_09_29_42_p.m..png';
const notifications = [{
  name: 'María L.',
  city: 'Tucumán'
}, {
  name: 'Valentina G.',
  city: 'Córdoba'
}, {
  name: 'Luciana M.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía R.',
  city: 'Rosario'
}, {
  name: 'Camila T.',
  city: 'Mendoza'
}, {
  name: 'Florencia B.',
  city: 'Mar del Plata'
}, {
  name: 'Natalia P.',
  city: 'Salta'
}, {
  name: 'Romina C.',
  city: 'La Plata'
}, {
  name: 'Daniela V.',
  city: 'Santa Fe'
}, {
  name: 'Agustina H.',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (dismissed) return;
    // Show after 3 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    // Hide after 6 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed) return;
    // Cycle through notifications every 15 seconds
    const cycleTimer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      setVisible(true);
    }, 15000);
    return () => clearInterval(cycleTimer);
  }, [dismissed]);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-1">
      {visible && !dismissed && <motion.div initial={{
      x: -320,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -320,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-6 left-4 z-50 max-w-xs w-72" data-id="element-2">
          <div className="bg-white rounded-xl shadow-2xl border border-pink-100 p-3 flex items-center gap-3 relative" data-id="element-3">
            <button onClick={() => {
          setVisible(false);
          setDismissed(true);
        }} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-4">
              <XIcon size={14} data-id="element-5" />
            </button>
            <img src={BOOK_IMAGE} alt="Gestando en Calma" className="w-12 h-12 object-cover rounded-lg flex-shrink-0" data-id="element-6" />
            <div className="flex-1 pr-4" data-id="element-7">
              <p className="text-xs text-gray-500 mb-0.5" data-id="element-8">🌸 Compra reciente</p>
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-9">
                {current.name} de {current.city}
              </p>
              <p className="text-xs text-pink-600 font-semibold" data-id="element-10">
                acaba de adquirir Gestando en Calma 🌸
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}